import React from "react";
import { activityRepo } from "../../services";
import { useApp } from "../../context/AppContext";
import { useI18n } from "../../i18n";
import { useMockCustomer } from "./useMockCustomer";
import { Card, Timeline, useAsync } from "../../components/ui";

export default function Activity() {
  const { orgId } = useApp();
  const { tx } = useI18n();
  const { customer } = useMockCustomer(orgId);
  const { data: activities } = useAsync(
    () => (customer ? activityRepo.all(orgId, (row) => row.customerId === customer.id) : Promise.resolve([])),
    [orgId, customer],
    []
  );

  return (
    <Card title={tx("ประวัติการใช้บริการทั้งหมด", "Full activity history")}>
      <Timeline items={activities || []} />
    </Card>
  );
}
